import { useEffect, useMemo, useRef, useState } from "react";
import { emplacarAPI } from "../../../../servicos/emplacar";
import ListagemFeedback from "../../../Listagem/feedback";
import ListagemOpcoes from "../../../Listagem/opcoes";
import Topo from "../../../Topo/topo";
import Paginacao from "../../../Listagem/paginacao";
import { formatarMoedaBRL, normalizarValorNumerico } from "../../../../constantes/relatorios";
import { exportarXLSX } from "../../../../utilitarios/excel";


function TabelaRelatorioEmplacamento() {

    const date = new Date();

    const breadcrumbs = ['Home','Relatório de Emplacamento'];
    const [PesquisaRelatorioEmplacamento, setPesquisaRelatorioEmplacamento] = useState([]);
    const [totalTaxa, setTotalTaxa] = useState(0);

    const [exibeErro, setExibeErro] = useState(false);    
    const [mensagemErro, setMensagemErro] = useState('');    

    const [mes, setmes] = useState(date.getMonth()+1);
    const [ano, setano] = useState(String(date.getFullYear()));
    const [anosDisponiveis, setAnosDisponiveis] = useState([]);

    const tableRef = useRef(null);

    const baseInputClass = 'form-input tw-h-11 tw-rounded-xl tw-border tw-border-transparent tw-bg-slate-50 tw-px-4 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-inner tw-transition-all placeholder:tw-text-slate-400 hover:tw-border-indigo-300 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-indigo-400 focus-visible:tw-border-indigo-500 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 dark:tw-border-slate-700 dark:tw-bg-slate-800 dark:tw-text-slate-100 dark:placeholder:tw-text-slate-500 dark:hover:tw-border-indigo-400/40 dark:focus-visible:tw-ring-indigo-300/60';

    useEffect(() => {
        fetchEmplacamentos(mes, ano);
    }, [mes, ano]);

    useEffect(() => {
        fetchAnosEmplacamento();
    }, []);

    useEffect(() => {
        const anoAtual = String(ano);
        if (anosDisponiveis.length > 0 && !anosDisponiveis.includes(anoAtual)) {
            setano(anosDisponiveis[anosDisponiveis.length - 1]);
        }
    }, [anosDisponiveis, ano]);

    async function fetchEmplacamentos(fMes,fAno){

        emplacarAPI.get(`/relatorio/${fMes}/${fAno}`)
        .then(resposta => {
            setPesquisaRelatorioEmplacamento(resposta.data);
            const taxaTotal = resposta.data.reduce((acc, item) => {
                const bruto = item?.fi100_vlr_emplacamento ?? item?.fi100_filiado?.fi100_vlr_emplacamento ?? 0;
                return acc + normalizarValorNumerico(bruto);
            }, 0);
            setTotalTaxa(taxaTotal);
        })
        .catch(erro => {          
            setTotalTaxa(0);
            if(erro?.resposta?.data?.message){
                setExibeErro(true);
                setMensagemErro(erro.resposta.data.message);
            }else{
                if (erro.response?.status === 401) {
                    setExibeErro(true);
                    setMensagemErro('Ops! Sessão Expirada! Faça um novo login.');
                  }else{
                    setExibeErro(true);
                    setMensagemErro('Ops! Ocorreu um erro inesperado.');
                  }                                           
            }        
        })               
        
    }        

    async function fetchAnosEmplacamento(){
        emplacarAPI.get('/relatorio/anos')
        .then(resposta => {
            const anos = (resposta.data?.anos || []).map((item) => String(item));
            setAnosDisponiveis(anos);
        })
        .catch(erro => {
            setAnosDisponiveis([]);
            if(erro?.resposta?.data?.message){
                setExibeErro(true);
                setMensagemErro(erro.resposta.data.message);
            }else{
                if (erro.response?.status === 401) {
                    setExibeErro(true);
                    setMensagemErro('Ops! Sess\u00E3o Expirada! Fa\u00E7a um novo login.');
                  }else{
                    setExibeErro(true);
                    setMensagemErro('Ops! Ocorreu um erro inesperado.');
                  }
            }
        })
    }        

    function FormatarDataHora(string){

        var retorno = '';
        if(string !== null){
            string = string.split("T");        
            var dataaux = string[0].split("-");
            var dataformatada = dataaux[2] + '/' + dataaux[1] + "/" + dataaux[0];      
            retorno = dataformatada + ' ' + string[1].substring(0,5) ;    
        }

        return retorno;

    }

    const cabecalhoExportacao = useMemo(
        () => [
            'Placa',
            'CNPJ',
            'Chassi',
            'Renavam',
            'Emplacamento',
            'Taxa por Emplacamento',
            'Processo',
            'Data Cadastro',
            'Situação',
            'Data Situação',
        ],
        [],
    );

    const handleExportarExcel = () => {
        const linhas = PesquisaRelatorioEmplacamento.map((emplacamento) => [
            emplacamento.ve101_dsc_placa || '',
            emplacamento.fi100_num_cnpj || emplacamento.fi100_filiado?.fi100_num_cnpj || '',
            emplacamento.ve101_dsc_chassi || '',
            emplacamento.ve101_num_renavam || '',
            emplacamento.ve101_cod_emplacar || '',
            normalizarValorNumerico(emplacamento?.fi100_vlr_emplacamento ?? emplacamento?.fi100_filiado?.fi100_vlr_emplacamento ?? 0),
            emplacamento.ve101_num_processo || '',
            FormatarDataHora(emplacamento.createdAt) || '',
            emplacamento.ve101_dsc_situacao || '',
            FormatarDataHora(emplacamento.ve101_dat_situacao) || '',
        ]);

        linhas.push([
            'Totais',
            '',
            '',
            '',
            '',
            normalizarValorNumerico(totalTaxa),
            '',
            '',
            '',
            '',
        ]);

        exportarXLSX({
            arquivo: 'ConexaoDetranPR_Emplacamento',
            aba: 'Emplacamento',
            cabecalho: cabecalhoExportacao,
            linhas,
            colunasNumericas: [5],
        });
    };

    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Relatório Emplacamento' breadcrumbs={breadcrumbs} btnincluir={false} admin={true}/>
                <ListagemFeedback
                    displayErro={exibeErro}
                    mensagemErro={mensagemErro}
                    displaySucesso={false}
                    mensagemSucesso={''}
                />
                <ListagemOpcoes
                    esconderTamanhoPagina={true}
                    esconderOpcaoFiltro={true}
                    esconderCampoFiltro={true}
                /> 
            </div>
        <div class="row row-padding-conteudo tw-items-end tw-gap-4" style={{marginBottom: '10px'}}>
            <div class="col-12">
                <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-gap-y-3">
                    <div class="tw-flex tw-items-center tw-gap-3">
                        <label for="mes" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600 dark:tw-text-white tw-leading-none">
                            Mês:
                        </label>
                        <select className={`${baseInputClass} tw-w-auto tw-min-w-[160px] dark:tw-text-white`} aria-label="Selecione" id="mes" name="mes" onChange={evento => {setmes(evento.target.value);fetchEmplacamentos(evento.target.value,ano);}} value={mes} >
                            <option value="1">Janeiro</option>
                            <option value="2">Fevereiro</option>
                            <option value="3">Março</option>
                            <option value="4">Abril</option>
                            <option value="5">Maio</option>
                            <option value="6">Junho</option>
                            <option value="7">Julho</option>
                            <option value="8">Agosto</option>
                            <option value="9">Setembro</option>
                            <option value="10">Outubro</option>
                            <option value="11">Novembro</option>
                            <option value="12">Dezembro</option>
                        </select>
                    </div>
                    <div class="tw-flex tw-items-center tw-gap-3">
                        <label for="ano" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600 dark:tw-text-white tw-leading-none">
                            Ano:
                        </label>
                        <select className={`${baseInputClass} tw-w-auto tw-min-w-[120px] dark:tw-text-white`} aria-label="Selecione" id="ano" name="ano" onChange={evento => {setano(evento.target.value);fetchEmplacamentos(mes,evento.target.value);}} value={ano} >
                            {anosDisponiveis.map((item) => (
                                <option key={item} value={item}>{item}</option>
                            ))}
                        </select>
                    </div>
                    <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-slate-600 dark:tw-text-white">
                        <span>Taxa Total:</span>
                        <span class="tw-text-base tw-font-semibold tw-text-slate-900 dark:tw-text-white">{formatarMoedaBRL(totalTaxa)}</span>
                    </div>
                    <div class="tw-flex tw-items-center tw-justify-end tw-gap-2 tw-ml-auto">
                        <button type="button" class="btn-export-excel" onClick={handleExportarExcel}>
                            <span class="material-symbols-outlined">cloud_download</span>
                            <span>Exportar Excel</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>    
        <div class="row row-padding-conteudo">
            <div class="col-12 mobile-hide tablet-hide">
                <div class="table-responvive">
                    <table class="table" ref={tableRef}>
                        <thead>
                            <tr>
                                <th class="topo" scope="col">Placa</th>
                                <th class="topo" scope="col">CNPJ</th>
                                <th class="topo" scope="col">Chassi</th>
                                <th class="topo" scope="col">Renavam</th>
                                <th class="topo" scope="col">Emplacamento</th>
                                <th class="topo" scope="col">Taxa por Emplacamento</th>
                                <th class="topo" scope="col">Processo</th>
                                <th class="topo" scope="col">Data Cadastro</th>
                                <th class="topo" scope="col">Situação</th>
                                <th class="topo" scope="col">Data Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {PesquisaRelatorioEmplacamento.map((emplacamento, indice) => (
                                <tr key={emplacamento.ve101_key_public || indice}>
                                    <td>
                                        {emplacamento.ve101_dsc_placa}
                                    </td>
                                    <td>
                                        {emplacamento.fi100_num_cnpj || emplacamento.fi100_filiado?.fi100_num_cnpj || '-'}
                                    </td>
                                    <td>
                                        {emplacamento.ve101_dsc_chassi}
                                    </td>
                                    <td>
                                        {emplacamento.ve101_num_renavam}
                                    </td>
                                    <td>
                                        {emplacamento.ve101_cod_emplacar}
                                    </td>
                                    <td>
                                        {formatarMoedaBRL(
                                            normalizarValorNumerico(emplacamento?.fi100_vlr_emplacamento ?? emplacamento?.fi100_filiado?.fi100_vlr_emplacamento ?? 0)
                                        )}
                                    </td>
                                    <td>
                                        {emplacamento.ve101_num_processo}
                                    </td>
                                    <td>
                                        {FormatarDataHora(emplacamento.createdAt)}
                                    </td>
                                    <td>
                                        {emplacamento.ve101_dsc_situacao}
                                    </td>
                                    <td>
                                        {FormatarDataHora(emplacamento.ve101_dat_situacao)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <Paginacao esconder={true} />
    </div>
);

}

export default TabelaRelatorioEmplacamento;

